import { Box, Typography, useMediaQuery } from "@mui/material";
import logo from "../../assets/images/OG-logo-removebg-preview.png";
import { useStyles } from "./style";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import tiktokIcon from "../../assets/icons/tiktok.jpg";
import { Link } from "react-router-dom";
const Footer = () => {
  const classes = useStyles();
  const mobile = useMediaQuery("(min-width: 600px)");
  const Ismobile = useMediaQuery("(max-width: 600px)");
  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <img src={logo} className={classes.image} alt="" />
        <Typography className={classes.description}>
          Merging Historic Gold Prospecting Heritage with Blockchain Technology
          in a Revolutionary NFT Platform
        </Typography>
        {mobile && <Typography pt={3}>2025 All Right Reserved</Typography>}
      </Box>
      <Box className={classes.rightContainer}>
        <Box className={classes.linksContainer}>
          <Typography className={classes.heading}>Links</Typography>
          {/* <Typography
            className={classes.description}
            component={Link}
            to="/faq"
          >
            FAQ
          </Typography> */}
          <Typography
            className={classes.description}
            component={Link}
            to="/about-us"
          >
            About us
          </Typography>
        </Box>
        <Box className={classes.linksContainer}>
          {" "}
          <Typography className={classes.heading}>Legal</Typography>
          <Typography
            className={classes.description}
            component={Link}
            to="/policies"
          >
            Terms of Service
          </Typography>
          <Typography
            component={Link}
            to="/legaldisclaimer"
            className={classes.description}
          >
            Legal Disclaimer{" "}
          </Typography>
        </Box>
        <Box className={classes.linksContainer}>
          {" "}
          <Typography className={classes.heading}>Contact</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Link
              to="https://www.instagram.com/otago_gold_nz"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <InstagramIcon className={classes.icon} />
            </Link>
            {/* <Link
              to="https://twitter.com/xNFTs_AI"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon className={classes.icon} />
            </Link>
            <Link
              to="https://www.tiktok.com/@xnfts.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={tiktokIcon}
                className={classes.icon}
                alt="/"
                width={"25px"}
              />
            </Link> */}
          </Box>
        </Box>
      </Box>
      {Ismobile && (
        <Box pt={10}>
          <Typography>2025 All Right Reserved</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Footer;
